<template>
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <div class="spinner-border" role="status" />
      <span>Loading...</span>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { sessionStorageKeys } from "@/utils/constants";
@Component
export default class VerifyEmailCallback extends Vue {
  created() {
    if (this.$route.query && this.$route.query.token) {
      this.saveToken(this.$route.query.token as string);
    } else {
      // Redirect to login page if token not exists in params.
      this.$router.push({ path: "/" });
    }
  }

  saveToken(token: string) {
    sessionStorage.setItem(sessionStorageKeys.verifyEmailToken, token);
    this.$router.push({ path: "/user/verify/email" });
  }
}
</script>
